import React, { Component } from 'react'
import './App.css'
import './Theme.css'
import './FeesPage.css'
import './EventPage.css'
import { Link, withRouter } from 'react-router-dom'
import Axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'
import Cookies from 'universal-cookie'
import { v4 as uuidv4 } from 'uuid'
import md5 from 'md5'
import Header from './layouts/Header'
import { API_URL } from './config'

const uuid6 = uuidv4().toUpperCase()

const cookies = new Cookies()
if (!cookies.get('clientid')) {
  cookies.set('clientid', uuidv4().toUpperCase())
}

/* ---------- small helpers ---------- */

const todayString = () => {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

const prettyDate = (value) => {
  if (!value) return ''
  const d = new Date(`${value}T00:00:00`)
  if (isNaN(d.getTime())) return value
  return d.toLocaleDateString('en-ZA', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

const money = (n) => `R${Number(n).toFixed(2)}`

// Turns "2026-11-20" + "18:00" or "6:30 PM" into a Date. Falls back to midnight if no time parses.
const toDateTime = (date, time) => {
  if (!date) return null
  const d = new Date(`${date}T00:00:00`)
  if (isNaN(d.getTime())) return null
  const t = /(\d{1,2})[:.h](\d{2})\s*(am|pm)?/i.exec(time || '')
  if (t) {
    let h = parseInt(t[1])
    const m = parseInt(t[2])
    const ap = (t[3] || '').toLowerCase()
    if (ap === 'pm' && h < 12) h += 12
    if (ap === 'am' && h === 12) h = 0
    d.setHours(h, m, 0, 0)
  }
  return d
}

const splitDiff = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000))
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    mins: Math.floor((s % 3600) / 60),
    secs: s % 60,
  }
}

const Countdown = ({ ms }) => {
  const { days, hours, mins, secs } = splitDiff(ms)
  const cells = [
    ['Days', days],
    ['Hours', hours],
    ['Mins', mins],
    ['Secs', secs],
  ]
  return (
    <div className="ep-count" role="timer" aria-label="Time until event starts">
      {cells.map(([label, v]) => (
        <div className="ep-count__cell" key={label}>
          <b>{String(v).padStart(2, '0')}</b>
          <small>{label}</small>
        </div>
      ))}
    </div>
  )
}

const tierOf = (cat) => {
  if (cat == 'VVIP') return { label: 'VVIP', cls: 'vvip' }
  if (cat == 'VIP') return { label: 'VIP', cls: 'vip' }
  return { label: 'General', cls: 'general' }
}

// Work out availability and the lowest price on offer for one ticket type.
const analyse = (item) => {
  const avail = parseInt(item.avail_tickets)
  const kidsAvail = parseInt(item.kids_tickets)
  const price = Number(item.price)
  const kidsPrice = Number(item.kids_price)
  const soldOut = avail <= 0 && kidsAvail <= 0
  const fewLeft = !soldOut && ((avail > 0 && avail <= 10) || (kidsAvail > 0 && kidsAvail <= 10))
  const isFree = price <= 0 && kidsPrice <= 0

  const options = []
  if (!soldOut) {
    if (isFree) options.push(0)
    if (price > 0 && !(avail <= 0)) options.push(price)
    if (kidsPrice > 0 && !(kidsAvail <= 0)) options.push(kidsPrice)
  }

  return {
    item,
    ...tierOf(item.ticket_cat),
    soldOut,
    fewLeft,
    isFree,
    price,
    kidsPrice,
    low: options.length ? Math.min(...options) : null,
  }
}

const Icon = ({ name, size = 20 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
  switch (name) {
    case 'calendar':
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="18" rx="3" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
      )
    case 'clock':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )
    case 'pin':
      return (
        <svg {...common}>
          <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      )
    case 'back':
      return (
        <svg {...common}>
          <path d="M15 18l-6-6 6-6" />
        </svg>
      )
    case 'share':
      return (
        <svg {...common}>
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
        </svg>
      )
    case 'arrow':
      return (
        <svg {...common}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      )
    case 'check':
      return (
        <svg {...common}>
          <path d="M20 6L9 17l-5-5" />
        </svg>
      )
    case 'ticket':
      return (
        <svg {...common}>
          <path d="M3 9a2 2 0 0 0 0 6v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a2 2 0 0 1 0-6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z" />
          <path d="M14 5v14" strokeDasharray="2 3" />
        </svg>
      )
    default:
      return null
  }
}

class Event extends Component {
  constructor(props) {
    super(props)
    this.eventId = props.match.params.eventId
    this.ticketsRef = React.createRef()
    this.copyTimer = null
    this.ticker = null
  }

  state = {
    error: null,
    detailsError: null,
    products: [],
    tickets: [],
    likeLabel: '',
    liked: '',
    likes: 0,
    loadBarProgress: false,
    fetchingTickets: true,
    description: '',
    venue: '',
    eventName: '',
    eventDate: '',
    startTime: '',
    endTime: '',
    poster: '',
    businessId: 0,
    eventId: 0,
    campaignStatus: 'stop',
    copied: false,
    now: Date.now(),
  }

  componentDidMount() {
    window.scrollTo(0, 0) // start at the top, not wherever the previous page was scrolled to
    const eventId = this.eventId

    const query = new URLSearchParams(this.props.location.search)

    const customerid = query.get('customerid')
    const clientid = cookies.get('clientid')

    // get user operating system
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows'
    } else if (/Android/.test(userAgent)) {
      os = 'Android'
    }

    // get user agent
    let browser = ''
    if (window.navigator.userAgent.indexOf('Edg/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('Edge/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('MSIE') > -1) {
      browser = 'Internet Explorer'
    } else if (
      window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Chrome') == -1
    ) {
      browser = 'Safari'
    } else if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox'
    } else if (window.navigator.userAgent.indexOf('Chrome') > -1) {
      browser = 'Chrome'
    } else if (window.navigator.userAgent.indexOf('Linux') > -1) {
      browser = 'Linux'
    }

    const device = os

    // get likes
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETNUMBEROFLIKES&eventid=${eventId}`,
      {
        withCredentials: true,
      },
    ).then((response) => {
      this.setState({ likes: response.data.likes })
    })

    // get event details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=FETCH-EVENT-DETAILS&customerid=${customerid}&eventid=${eventId}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        document.title = 'Karamale | ' + response.data.eventName
        this.setState({
          description: response.data.description,
          venue: response.data.venue,
          eventName: response.data.eventName,
          eventDate: response.data.eventDate,
          startTime: response.data.startTime,
          poster: response.data.poster,
          businessId: response.data.businessId,
          endTime: response.data.endTime,
          campaignStatus: response.data.campaignStatus,
        })

        // Calculate impressions (needs the businessId, so it runs once details are in)
        Axios.get(
          `${API_URL}/apps/kscanner/webservices.php?query=INSERTIMPRESSION&eventid=${eventId}&businessid=${response.data.businessId}&clientid=${clientid}&device=${device}&browser=${browser}`,
          {
            withCredentials: true,
          },
        ).catch(() => {})
      })
      .catch((err) => {
        this.setState({ detailsError: err })
      })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=TICKETS&eventid=${this.eventId}`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          tickets: response.data,
          fetchingTickets: false,
        })
      })
      .catch(() => {
        this.setState({ fetchingTickets: false })
      })

    // drives the countdown
    this.ticker = setInterval(() => this.setState({ now: Date.now() }), 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.copyTimer)
    clearInterval(this.ticker)
  }

  share = async () => {
    const url = window.location.href
    try {
      if (navigator.share) {
        await navigator.share({ title: this.state.eventName, url })
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(url)
        this.setState({ copied: true })
        clearTimeout(this.copyTimer)
        this.copyTimer = setTimeout(() => this.setState({ copied: false }), 2000)
      }
    } catch (e) {
      // user cancelled share
    }
  }

  scrollToTickets = () => {
    if (this.ticketsRef.current) {
      this.ticketsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  goBack = () => this.props.history.goBack()

  /* ---------- checkout link (one link, all ticket types) ---------- */

  checkoutTarget = (info, fulldate) => {
    const open = info.filter((t) => !t.soldOut)
    if (open.length === 0) return null

    const query = new URLSearchParams(this.props.location.search)
    const accountid = query.get('accountid')
    const customerid = query.get('customerid')
    const accounttype = query.get('accounttype')
    const customername = query.get('customername')
    const email = query.get('email')
    const phone = query.get('phone')
    const previousPage = query.get('previousPage')
    const category = query.get('category')
    const campaignStatus = this.state.campaignStatus
    const posterUri = `${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`

    // Every ticket type still on sale; checkout lets the buyer mix them.
    const list = open.map((t) => ({
      ticketid: t.item.id,
      ticketref: t.item.ticketref,
      category: t.label,
      price: t.item.price,
      kids_price: t.item.kids_price,
      avail_tickets: t.item.avail_tickets,
      kids_tickets: t.item.kids_tickets,
      sold: t.item.sold,
      kids_sold: t.item.kids_sold,
    }))

    // The cheapest type is passed as the legacy single-ticket fields, so the
    // current checkout keeps working until it reads `tickets`.
    const def = open.reduce((a, b) => ((b.low ?? Infinity) < (a.low ?? Infinity) ? b : a))
    const item = def.item

    const params = {
      fulldate: fulldate,
      eventDate: this.state.eventDate,
      price: item.price,
      kids_price: item.kids_price,
      ticketid: item.id,
      ticketref: item.ticketref,
      command: 1,
      customerid: customerid,
      posterUri: this.state.poster,
      customername: customername,
      email: email,
      phone: phone,
      accountid: accountid,
      accounttype: accounttype,
      eventtype: category,
      province: this.state.province,
      venue: this.state.venue,
      description: this.state.description,
      businessid: this.state.businessId,
      eventid: this.eventId,
      poster: posterUri,
      eventname: this.state.eventName,
      eventday: this.state.eventDate,
      starttime: this.state.startTime,
      endtime: this.state.endTime,
      previousPage: previousPage,
      prevPage: 'event',
      campaignStatus: campaignStatus,
      category: def.label,
      sold: item.sold,
      avail_tickets: item.avail_tickets,
      kids_sold: item.kids_sold,
      kids_tickets: item.kids_tickets,
      tickets: JSON.stringify(list),
    }

    const search = Object.keys(params)
      .map((k) => `${k}=${encodeURIComponent(params[k])}`)
      .join('&')

    return {
      pathname: '/checkout/' + this.eventId + '/' + md5(uuid6),
      search,
      state: {
        fromHome: true,
        fulldate: fulldate,
        eventDate: this.state.eventDate,
        price: item.price,
        ticketid: item.id,
        ticketref: item.ticketref,
        command: 1,
        customerid: customerid,
        posterUri: posterUri,
        customername: customername,
        email: email,
        phone: phone,
        accountid: accountid,
        accounttype: accounttype,
        category: def.label,
        venue: this.state.venue,
        description: this.state.description,
        businessid: this.state.businessId,
        eventid: this.eventId,
        poster: this.state.poster,
        eventname: this.state.eventName,
        eventday: this.state.eventDate,
        starttime: this.state.startTime,
        endtime: this.state.endTime,
        previousPage: previousPage,
        prevPage: 'event',
        campaignStatus: campaignStatus,
        tickets: list,
      },
    }
  }

  /* ---------- ticket types summary (read-only; choosing happens at checkout) ---------- */

  tierList = (info) => (
    <ul className="ep-tiers">
      {info.map((t, i) => (
        <li key={t.item.id || i} className={`ep-tierrow ${t.soldOut ? 'is-sold' : ''}`}>
          <span className={`ep-tier ep-tier--${t.cls}`}>{t.label}</span>
          <span className="ep-tierrow__price">
            {t.isFree && <b>Free</b>}
            {t.price > 0 && (
              <span>
                <small>Adults</small> <b>{money(t.price)}</b>
              </span>
            )}
            {t.kidsPrice > 0 && (
              <span>
                <small>Kids</small> <b>{money(t.kidsPrice)}</b>
              </span>
            )}
          </span>
          {t.soldOut && <span className="ep-flag ep-flag--sold">Sold out</span>}
          {t.fewLeft && <span className="ep-flag ep-flag--few">Few left</span>}
        </li>
      ))}
    </ul>
  )

  /* ---------- render ---------- */

  render() {
    const { loadBarProgress, detailsError } = this.state

    const fulldate = todayString()
    const eventDate = this.state.eventDate
    const saleOpen = eventDate >= fulldate
    const loadingDetails = !this.state.eventName && !detailsError
    const loggedIn = localStorage.getItem('customerid') !== null
    const running = this.state.campaignStatus == 'running'
    const posterUri = `${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`
    const hasPoster = !!this.state.poster

    // countdown
    const startAt = toDateTime(this.state.eventDate, this.state.startTime)
    let endAt = this.state.endTime ? toDateTime(this.state.eventDate, this.state.endTime) : null
    if (startAt && !endAt) {
      endAt = new Date(startAt)
      endAt.setHours(23, 59, 59, 999)
    } else if (startAt && endAt <= startAt) {
      endAt.setDate(endAt.getDate() + 1) // event runs past midnight
    }
    const untilStart = startAt ? startAt.getTime() - this.state.now : null
    const isLive = !!startAt && untilStart <= 0 && this.state.now < endAt.getTime()
    const showCountdown = untilStart !== null && untilStart > 0

    const info = (this.state.tickets || []).map(analyse)
    const lows = info.filter((t) => t.low !== null).map((t) => t.low)
    const fromPrice = lows.length ? Math.min(...lows) : null
    const allSold = info.length > 0 && info.every((t) => t.soldOut)
    const fromLabel =
      fromPrice === null
        ? allSold
          ? 'Sold out'
          : '—'
        : fromPrice === 0
          ? 'Free'
          : money(fromPrice)
    const target = this.checkoutTarget(info, fulldate)
    const canBuy = saleOpen && running && !loadingDetails && !this.state.fetchingTickets && !!target

    if (detailsError) {
      return (
        <div className="fp-page ep-page">
          <Header />
          <div className="ep-error">
            <h2>We couldn’t load this event</h2>
            <p>Check your connection and try again.</p>
            <button className="ep-btn ep-btn--primary" onClick={() => window.location.reload()}>
              Try again
            </button>
          </div>
        </div>
      )
    }

    let statusClass = ''
    let statusText = 'Tickets on sale'
    if (!saleOpen) {
      statusClass = 'ep-status--ended'
      statusText = 'Event ended'
    } else if (!running) {
      statusClass = 'ep-status--paused'
      statusText = 'Not on sale right now'
    }

    // Main call to action: straight to checkout when logged in, otherwise to the panel.
    const cta = (className, label) =>
      loggedIn && target ? (
        <Link to={target} className={className}>
          <Icon name="ticket" size={18} /> {label}
        </Link>
      ) : (
        <button type="button" className={className} onClick={this.scrollToTickets}>
          <Icon name="ticket" size={18} /> {label}
        </button>
      )

    return (
      <div className="fp-page ep-page">
        <Header />
        {loadBarProgress && <TopBarProgress />}

        {/* ---------- hero ---------- */}
        <section className="ep-hero">
          {hasPoster && (
            <div className="ep-hero__bg" style={{ backgroundImage: `url("${posterUri}")` }} />
          )}
          <div className="ep-hero__shade" />
          <div className="ep-wrap ep-hero__inner">
            <button type="button" className="ep-back" onClick={this.goBack}>
              <Icon name="back" size={18} /> Back
            </button>

            {loadingDetails ? (
              <div className="ep-hero__grid">
                <div className="ep-sk ep-sk--poster" />
                <div className="ep-hero__info">
                  <span className="ep-sk ep-sk--line" style={{ width: 150 }} />
                  <span className="ep-sk ep-sk--line" style={{ width: '80%', height: 52 }} />
                  <span className="ep-sk ep-sk--line" style={{ width: '60%', height: 64 }} />
                </div>
              </div>
            ) : (
              <div className="ep-hero__grid">
                <div className="ep-poster">
                  {hasPoster ? (
                    <img src={posterUri} alt={this.state.eventName} />
                  ) : (
                    <div className="ep-poster__empty">
                      <Icon name="ticket" size={56} />
                    </div>
                  )}
                </div>

                <div className="ep-hero__info">
                  <span className={`ep-status ${statusClass}`}>
                    <i /> {statusText}
                  </span>
                  <h1 className="ep-title">{this.state.eventName}</h1>

                  <ul className="ep-facts">
                    <li className="ep-fact">
                      <span className="ep-fact__ic">
                        <Icon name="calendar" size={18} />
                      </span>
                      <span className="ep-fact__tx">
                        <small>Date</small>
                        <b>{prettyDate(this.state.eventDate)}</b>
                      </span>
                    </li>
                    <li className="ep-fact">
                      <span className="ep-fact__ic">
                        <Icon name="clock" size={18} />
                      </span>
                      <span className="ep-fact__tx">
                        <small>Time</small>
                        <b>
                          {this.state.startTime}
                          {this.state.endTime ? ` – ${this.state.endTime}` : ''}
                        </b>
                      </span>
                    </li>
                    <li className="ep-fact">
                      <span className="ep-fact__ic">
                        <Icon name="pin" size={18} />
                      </span>
                      <span className="ep-fact__tx">
                        <small>Venue</small>
                        <b>{this.state.venue}</b>
                      </span>
                    </li>
                  </ul>

                  {showCountdown && <Countdown ms={untilStart} />}
                  {isLive && (
                    <span className="ep-status">
                      <i /> Happening now
                    </span>
                  )}

                  <div className="ep-hero__buy">
                    {saleOpen && running && fromPrice !== null && (
                      <div className="ep-from">
                        <small>{fromPrice === 0 ? 'Entry' : 'Tickets from'}</small>
                        <b>{fromLabel}</b>
                      </div>
                    )}
                    <div className="ep-hero__actions">
                      {canBuy && cta('ep-btn ep-btn--primary ep-btn--lg', 'Get tickets')}
                      <button type="button" className="ep-btn ep-btn--glass" onClick={this.share}>
                        <Icon name="share" size={18} />{' '}
                        {this.state.copied ? 'Link copied' : 'Share'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* ---------- body ---------- */}
        <main className="ep-wrap ep-body">
          <div className="ep-content">
            {this.state.description ? (
              <section className="ep-card">
                <h2 className="ep-h2">About this event</h2>
                <div
                  className="co-prose"
                  dangerouslySetInnerHTML={{
                    __html: /<\/?[a-z][\s\S]*>/i.test(this.state.description)
                      ? this.state.description
                      : this.state.description.replace(/\r?\n/g, '<br />'),
                  }}
                />
              </section>
            ) : null}

            {this.state.venue ? (
              <section className="ep-card">
                <div className="ep-card__head">
                  <h2 className="ep-h2">Venue</h2>
                  <a
                    className="ep-btn ep-btn--outline ep-btn--sm"
                    href={
                      'https://www.google.com/maps/search/?api=1&query=' +
                      encodeURIComponent(this.state.venue)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name="pin" size={16} /> Open in Maps
                  </a>
                </div>
                <p className="ep-venue">{this.state.venue}</p>
                <div className="ep-map">
                  <iframe
                    title="Event location"
                    loading="lazy"
                    src={
                      'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
                      encodeURIComponent(this.state.venue)
                    }
                  ></iframe>
                </div>
              </section>
            ) : null}
          </div>

          {/* ---------- tickets ---------- */}
          <aside className="ep-panel" id="tickets" ref={this.ticketsRef}>
            <div className="ep-panel__card">
              {loadingDetails || this.state.fetchingTickets ? (
                <div className="ep-loading" aria-busy="true">
                  <i />
                  <i />
                </div>
              ) : !saleOpen ? (
                <div className="ep-note ep-note--warn">
                  This event has ended. Ticket sales are closed.
                </div>
              ) : !running ? (
                <div className="ep-note ep-note--info">
                  This event isn’t active right now. Please check back later.
                </div>
              ) : info.length === 0 ? (
                <div className="ep-note ep-note--info">
                  No tickets have been released for this event yet.
                </div>
              ) : (
                <>
                  <div className="ep-panel__top">
                    <small>{fromPrice === 0 ? 'Entry' : 'Tickets from'}</small>
                    <div className="ep-panel__price">{fromLabel}</div>
                    {fromPrice !== null && fromPrice > 0 && <span>per ticket</span>}
                  </div>

                  <p className="ep-panel__label">Ticket types</p>
                  {this.tierList(info)}

                  <ul className="ep-perks">
                    <li>
                      <Icon name="check" size={16} /> Pick your ticket types at checkout
                    </li>
                    <li>
                      <Icon name="check" size={16} /> Mix types in one order, one ticket each
                    </li>
                    <li>
                      <Icon name="check" size={16} /> Digital tickets, scanned at the door
                    </li>
                  </ul>

                  {allSold ? (
                    <div className="ep-note ep-note--warn">All tickets are sold out.</div>
                  ) : loggedIn ? (
                    target && (
                      <div className="ep-panel__cta">
                        <Link
                          to={target}
                          className="ep-btn ep-btn--primary ep-btn--lg ep-btn--block"
                        >
                          Get tickets <Icon name="arrow" size={18} />
                        </Link>
                      </div>
                    )
                  ) : (
                    <div className="ep-auth">
                      <p>Log in or register to buy tickets.</p>
                      <div className="ep-auth__row">
                        <Link to="/login" className="ep-btn ep-btn--primary">
                          Log in
                        </Link>
                        <Link to="/customer-registration" className="ep-btn ep-btn--outline">
                          Register
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </aside>
        </main>

        {/* ---------- mobile action bar ---------- */}
        {canBuy && (
          <div className="ep-bar">
            <div className="ep-bar__price">
              <small>{fromPrice === 0 ? 'Entry' : 'From'}</small>
              <b>{fromLabel}</b>
            </div>
            {cta('ep-btn ep-btn--primary', 'Get tickets')}
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(Event)
